<template>
    <footer class="footer_sec"
        style="background-color: rgb(0, 0, 0); color: rgb(255, 255, 255); padding: 15px 0px; margin-top: 50px; text-align: center;">
        <div class="MuiGrid-root MuiGrid-container MuiGrid-spacing-xs-2 f_container css-12n0uxm-MuiGrid-root">
            <div class="MuiGrid-root MuiGrid-item MuiGrid-grid-xs-12 css-1idn90j-MuiGrid-root"
                style="text-align: center; padding-right: 30px;">
                <div class="justify-content-center nav">
                    <a role="button" class="nav-link" tabindex="0" href="#">
                        <router-link to="/sleephealthscreen">Home</router-link>
                    </a>
                    <a role="button" class="nav-link" tabindex="0" href="#">
                        <router-link to="/sleephealthscreen/about">About</router-link>
                    </a>
                    <a role="button" class="nav-link" tabindex="0" href="#">
                        <router-link to="/sleephealthscreen/description-initiative">Description of the
                            Initiative</router-link>
                    </a>
                </div>
            </div>
        </div>
        <div class="MuiGrid-root MuiGrid-container css-1lym95h-MuiGrid-root" style="margin-top: 15px;">
            <div class="MuiGrid-root MuiGrid-item css-13i4rnv-MuiGrid-root">
                <p>© {{ currentDate }} Sleep Health Screen</p>
            </div>
        </div>
    </footer>
</template>

<script>
export default {
    name: "FooterComponent",
    data() {
        return {
            currentDate: this.getCurrentDate(),
        };
    },
    methods: {
        getCurrentDate() {
            const today = new Date();
            return today.getFullYear();
        },
    },
};
</script>

<style scoped>
.footer_sec {
    font-size: 14px;
}

.f_container {
    border-bottom: 1px solid rgba(255, 255, 255, 0.3);
    padding-bottom: 30px;
    padding-top: 15px;
}

.f_container .justify-content-center {
    gap: 50px;
}

.f_container .nav-link,
.f_container .nav-link a {
    color: #ffffff !important;
    font-size: 1.2rem;
    font-weight: 500;
    text-decoration: none;
}

.footer_sec p {
    margin-bottom: 0;
    color: #ffffff;
    font-size: 1rem;
}

@media screen and (max-width: 767px) {
    .f_container .justify-content-center {
        gap: 20px;
    }
}
</style>